import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { trigger, state, style, transition, animate } from '@angular/animations';


@Component({
  selector: 'app-wizard-answers-multi-menu',
  templateUrl: './wizard-answers-multi-menu.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './wizard-answers-multi-menu.component.scss'],
  //host: {'class': 'app-wizard-answers-menu'},
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(-220%,0,0)'

      })),
      state('out', style({
        transform: 'translate3d(135px, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),

    trigger('slideInOutMobile', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(0,500%,0)'

      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),
    trigger('reglageSlideOut', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(0,500%,0)'

      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),
    trigger('slideInOutRigth', [
      state('in', style({
        transform: 'translate3d(200%,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideInOutForme', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(-240%,0,0)'

      })),
      state('out', style({
        transform: 'translate3d(135px, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ])
  ]

})
export class WizardAnswersMultiMenuComponent extends WizardHpBaseComponent implements OnInit {
  @Input() answer_index;
  @Input() question_code;
  @Input() multiMenuAnswerState;
  @Input() answers :any;
  @Input() questionTitleAnswersProduct:any;
  @Input() groupsData:any;
  answers_variable = [];
  answers_variableId = [];
  filterDisplay = false;
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);

  }

  ngOnInit(): void {
    super.ngOnInit();

    
  }
  pushVariable(index_, id) {
    this.answers_variableId[index_] = id;
  }

  getVariable(isValeur) {
    return (isValeur === "valeur") ? this.answers_variable.join() : this.answers_variableId.join()
  }
  getClassName(keywords) {
    if (keywords) {
      return keywords.replace(/,/gi, ' ').toLowerCase();
    }
  }
  showFilter() {
    this.filterDisplay = (this.filterDisplay) ? false : true;
  }
  showViewModal(keyword) {

    const gammeInViewInt = (element) => element === keyword;
  
    return this.getHpService().getConfig().herculepro.viewInterieurIn.findIndex(gammeInViewInt)
  }

}
